'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ProjectInfo = undefined;

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _pluralize = require('pluralize');

var _pluralize2 = _interopRequireDefault(_pluralize);

var _CloudinaryImage = require('web-makeup/dist/CloudinaryImage');

var _CloudinaryImage2 = _interopRequireDefault(_CloudinaryImage);

var _reactIntl = require('react-intl');

var _TextComponents = require('../TextComponents');

var _location = require('../helpers/location');

var _image = require('../helpers/image');

var _ProjectInfo = require('./ProjectInfo.style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var ProjectInfo = exports.ProjectInfo = function ProjectInfo(_a) {
    var project = _a.project,
        projectId = _a.projectId;
    var name = project.name,
        projectDueDate = project.dueDate,
        _b = project.videos,
        videos = _b === void 0 ? [] : _b,
        _c = project.shoots,
        shoots = _c === void 0 ? [] : _c,
        location = project.location,
        product = project.product,
        thumbnailUrl = project.thumbnailUrl;
    var locationText = (0, _location.formatLocation)(location);
    var dueDate = projectDueDate ? (0, _moment2.default)(projectDueDate) : null;
    var productImage = product && product.image && (0, _image.getCloudinaryUrl)(product.image) || thumbnailUrl;
    var env = window.env || {};
    return React.createElement("a", { href: env.GEN1_BASE_URL + "/video_projects/" + projectId }, React.createElement(_ProjectInfo.Header, { background: productImage }, React.createElement(_ProjectInfo.HeaderContent, null, React.createElement(_ProjectInfo.InfoTitle, { as: "h2", textAlign: "left", fontSize: "h1", fontWeight: "black", color: "white", overflow: "hidden" }, name), React.createElement(_ProjectInfo.InfoShoots, { as: "h3", textAlign: "left", fontSize: "h4", color: "white" }, videos.length + "x " + (0, _pluralize2.default)('Video', videos.length) + " - " + shoots.length + "x " + (0, _pluralize2.default)('Shoot', shoots.length)), React.createElement(_ProjectInfo.InfoLocation, { as: "h4", textAlign: "left", fontSize: "h46", color: "white" }, React.createElement(_CloudinaryImage2.default, { useSourceFormat: true, source: {
            id: 'v1/-homepage-icons/-footer/icon-pin-white',
            type: 'upload'
        } }), ' ', locationText), React.createElement(_ProjectInfo.Schedule, null, React.createElement(_TextComponents.ChildText, { textAlign: "right", color: "#BABABA", size: "0.75rem" }, React.createElement(_reactIntl.FormattedMessage, { id: "Scheduled" })), React.createElement(_ProjectInfo.InfoDate, { fontWeight: "bold", textAlign: "right", size: "1.25rem" }, dueDate ? React.createElement(React.Fragment, null, React.createElement("strong", null, dueDate.format('MMM Do')), ' - ', React.createElement("span", null, dueDate.format('h A'))) : React.createElement(_reactIntl.FormattedMessage, { id: "project.scheduled_unknown" }))))));
};
exports.default = React.memo(ProjectInfo);
//# sourceMappingURL=ProjectInfo.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-ui/dist/order/views/pay-page/ProjectInfo/ProjectInfo.js
// module id = 1975
// module chunks = 0